import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BluechatDeliveryStatus } from '../../shared/bluechat-delivery.model';
import { ETAType } from '../../../shared/eta-type.model';

@Component({
  selector: 'app-bluechat-delivery-status',
  templateUrl: './bluechat-delivery-status.component.html',
  styleUrls: ['./bluechat-delivery-status.component.scss']
})
export class BluechatDeliveryStatusComponent {

  @Input() public status: BluechatDeliveryStatus;
  @Input() public eta: string;
  @Input() public etaType: ETAType;
  @Input() public displayEta = true;
  @Input() public timezoneOffset: string;
  @Output() etaComponentClicked = new EventEmitter();

  public statusClass: string;
  public statusNameKey: string

  public BLUECHAT_DELIVERY_STATUS = BluechatDeliveryStatus;

  openEtaDetailList() {
    this.etaComponentClicked.emit();
  }
}
